import { render, staticRenderFns } from "./Management.vue?vue&type=template&id=7dd3876a&scoped=true"
import script from "./Management.vue?vue&type=script&lang=js"
export * from "./Management.vue?vue&type=script&lang=js"
import style0 from "./Management.vue?vue&type=style&index=0&id=7dd3876a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd3876a",
  null
  
)

export default component.exports